// extracted by mini-css-extract-plugin
module.exports = {"root":"Map-module--root--eoE-x","country":"Map-module--country--2SJff","tooltip":"Map-module--tooltip--Qng7t","touch":"Map-module--touch--3OkiC"};